var map = {
	"./en/illustratepic_01.png": "+k7w",
	"./ja/illustratepic_01.png": "JpjK",
	"./ko/illustratepic_01.png": "D6Hx",
	"./zh-CN/illustratepic_01.png": "Bz9/",
	"./zh-TW/illustratepic_01.png": "eRzz"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "C9Dm";


//////////////////
// WEBPACK FOOTER
// ./static/images ^\.\/.*\/illustratepic_01\.png$
// module id = C9Dm
// module chunks = 1